<template>
  <div class="pt-2">
    <v-card flat>
      <v-form>
        <v-row no-gutters align="center" justify="space-around">
          <v-col cols="12" sm="1" style="text-align: right">
            <label>选择门店：</label>
          </v-col>
          <v-col cols="12" sm="3">
            <pd-shop-multiple-list
                v-model="filter.shopIds"
                isSearch
            ></pd-shop-multiple-list>
          </v-col>
          <v-col cols="12" sm="1" style="text-align: right">
            <label>选择年度：</label>
          </v-col>
          <v-col cols="12" sm="2">
            <el-date-picker
                v-model="filter.year"
                type="year"
                placeholder="选择年"
                format="yyyy 年"
                value-format="yyyy">
            </el-date-picker>
          </v-col>
          <v-col cols="12" sm="1" style="text-align: right">
            <label>状态：</label>
          </v-col>
          <v-col cols="12" sm="3">
            <v-select
                v-model="filter.status"
                :items="statusList"
                item-text="name"
                item-value="id"
                outlined
                dense
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="1"></v-col>
          <v-col cols="12" sm="2">
            <v-btn color="primary" class="mr-2" depressed @click="handleSearch" v-if="_hasButtonPermission('查询')"
            >查询
            </v-btn>
            <v-btn depressed @click="handleResetSearch" v-if="_hasButtonPermission('查询')">重置</v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-data-table
          :headers="headers"
          fixed-header
          :items="desserts"
          class="elevation-1 mt-2"
          :loading="loading"
          :server-items-length="totalDesserts"
          :page.sync="filter.pageNum"
          :items-per-page.sync="filter.pageSize"
          @update:page="handlePageChanged"
          @update:items-per-page="handlePageSizeChanged"
      >
        <!--        <template v-slot:top>-->
        <!--          <v-toolbar flat>-->
        <!--            <v-btn color="primary" depressed class="mr-2" @click="doSource">-->
        <!--             计划年度生成-->
        <!--            </v-btn>-->
        <!--          </v-toolbar>-->
        <!--        </template>-->
        <template v-slot:[`item.status`]="{ item }">
          {{ _jungleStatus(item.status) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn text color="primary" small @click="viewDetail(item)" v-if="_hasButtonPermission('查看')"
          >查看
          </v-btn
          >
          <v-btn :disabled="item.status!=4" text color="primary" small @click="adjustMatter(item)"
                 v-if="_hasButtonPermission('事项调改')"
          >事项调改
          </v-btn
          >
          <!--<v-btn text color="primary"
            @click="clickAudit(item.id)"
            small
            :disabled="!(item.status==2&&_hasButtonPermission('审批'))"
          >
            审批
          </v-btn>-->
        </template>
      </v-data-table>
      <!--导入弹窗-->
      <v-dialog persistent v-model="sourceDialog" width="900">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"
          >预算年度生成
          </v-card-title
          >
          <v-card-text>
            <v-container>
              <v-form ref="formSource" v-model="sourceValid">
                <v-row>
                  <v-col cols="12" sm="2" style="text-align: right">
                    <label>生成门店：</label>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <pd-shop-multiple-list
                        v-model="sourceModel.shopIds"
                    ></pd-shop-multiple-list>
                  </v-col>
                  <v-col cols="12" sm="2" style="text-align: right">
                    <label>生成年度：</label>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <el-date-picker
                        v-model="sourceModel.year"
                        type="year"
                        placeholder="选择年"
                        format="yyyy 年"
                        value-format="yyyy">
                    </el-date-picker>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" :disabled="btnDisabled" text @click="handleSource"> 生成</v-btn>
            <v-btn text @click="hideSource"> 取消</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--同步事项-->
      <v-dialog persistent v-model="syncDialog" width="800">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"
          >同步事项
          </v-card-title
          >
          <v-card-text>
            <v-container>
              <v-form ref="formEdit" v-model="syncValid">
                <v-row dense>
                  <v-col :cols="4">
                    <v-text-field
                        dense
                        outlined
                        readonly
                        :label="syncForm.planId.label"
                        v-model="syncModel.planId"
                        required
                    />
                  </v-col>
                  <v-col :cols="6">
                    <v-text-field
                        dense
                        outlined
                        :label="syncForm.matterIds.label"
                        :placeholder="syncForm.matterIds.placeholder"
                        v-model="syncModel.matterIds"
                        required
                        :rules="syncForm.matterIds.rules"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" :disabled="btnDisabled" text @click="handleSync"> 同步</v-btn>
            <v-btn text @click="hideSync"> 取消</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>
<script>
import {default as ShopPlanApi} from "@/api/pd/plan/ShopPlanApi.js";

export default {
  props: {
    buttonPriviledgeList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      statusList: [
        {id: 1, name: "待录入"},
        {id: 2, name: "待提交"},
        {id: 3, name: "待审批"},
        {id: 4, name: "已审批"}
      ],
      statusMap: {
        "1": "待录入",
        "2": "待提交",
        "3": "待审批",
        "4": "已审批"
      },
      filter: {
        shopIds: [],
        year: null,
        pageNum: 1,
        pageSize: 15
      },
      headers: [
        {
          text: "记录编号",
          value: "id",
          sortable: false,
          width: 90,
          divider: true,
        },
        {
          text: "门店名称",
          value: "shopName",
          sortable: false,
          width: 180,
          divider: true,
        },
        {
          text: "年度",
          sortable: false,
          value: "year",
          width: 100,
          divider: true,
        },
        {
          text: "状态",
          sortable: false,
          value: "status",
          width: 90,
          divider: true,
        },
        {
          text: "总事项",
          sortable: false,
          value: "totalAmount",
          width: 80,
          divider: true,
        },
        {
          text: "未录入事项",
          sortable: false,
          value: "notEnteredAmount",
          width: 80,
          divider: true,
        },
        {
          text: "已录入事项",
          sortable: false,
          value: "enteredAmount",
          width: 80,
          divider: true,
        },
        {
          text: "最后修改人",
          align: "start",
          sortable: false,
          value: "updateBy",
          width: 150,
          divider: true,
        },
        {
          text: "最后修改时间",
          align: "start",
          sortable: false,
          value: "updateTime",
          width: 180,
          divider: true,
        },
        {
          text: "操作",
          align: "start",
          sortable: false,
          value: "actions",
          width: 220,
          divider: true,
        },
      ],
      desserts: [],
      loading: false,
      totalDesserts: 0,
      sourceDialog: false,
      sourceValid: false,
      sourceModel: {
        shopIds: [],
        year: null
      },
      btnDisabled: false,
      syncDialog: false,
      syncValid: false,
      syncModel: {
        planId: null,
        matterIds: null
      },
      syncForm: {
        planId: {
          label: '记录编号',
        },
        matterIds: {
          label: '事项编号',
          placeholder: '请填写业务事项编号，多个用 , 隔开',
          rules: [(v) => !!v || '必填']
        }
      }
    };
  },
  mounted() {
    // this.getDataFromApi();
  },
  methods: {
    viewDetail(item) {
      this.$emit("viewDetailCallback", {formStatus: 'detail', planId: item.id})
    },
    adjustMatter(item) {
      this.$emit("adjustCallback", {formStatus: 'adjust', planId: item.id})
    },
    handleSearch() {
      // 校验门店必选
      if (!this.filter.shopIds || this.filter.shopIds.length == 0) {
        this.$dialog.error({
          title: '错误',
          text: '请选择门店'
        })
        return
      }
      this.getDataFromApi();
    },
    handleResetSearch() {
      this.filter = {
        shopIds: [],
        year: null,
        pageNum: 1,
        pageSize: 15
      };
      // this.getDataFromApi();
    },
    handlePageChanged(pageNum) {
      this.filter.pageNum = pageNum;
      this.getDataFromApi();
    },
    handlePageSizeChanged(pageSize) {
      if (pageSize == -1) {
        pageSize = 100;
      }
      this.filter.pageNum = 1;
      this.filter.pageSize = pageSize;
      this.getDataFromApi();
    },
    async getDataFromApi() {
      let me = this;
      me.loading = true;
      let queryUserResp = await ShopPlanApi.list({
        shopIds: me.filter.shopIds.join(','),
        year: me.filter.year,
        status: me.filter.status,
        pageNum: me.filter.pageNum,
        pageSize: me.filter.pageSize
      });
      console.log("load user returned;");
      console.log(queryUserResp);
      let data = queryUserResp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取维保预算列表失败" : msg;
        me.loading = false;
        throw new Error(msg);
      }
      if (!data.data || !data.data.rows) {
        me.loading = false;
        throw new Error("获取维保预算列表情况失败(无会话数据)");
      }
      me.loading = false;
      me.desserts = data.data.rows;
      me.totalDesserts = data.data.total;
    },
    doSource() {
      this.sourceDialog = true;
    },
    hideSource() {
      this.sourceDialog = false;
      // 还要重置数据
      this.sourceModel = {
        shopIds: [],
        year: null
      }
    },
    async handleSource() {
      let me = this;
      let sourceValid = me.sourceValid;
      if (!sourceValid) {
        me.$dialog.error({
          title: "错误",
          text: "请完善信息",
        });
        return;
      }
      me.btnDisabled = true
      let res = await ShopPlanApi.sourceData(me.sourceModel);
      console.log("导入结果", res);
      if (res.data.code === 200) {
        me.$dialog.info({
          text: res.data.msg,
          title: "操作成功",
        });
        me.getDataFromApi();
        me.hideSource();
      } else {
        me.$dialog.error({
          text: res.data.msg_detail,
          title: res.data.msg,
        });
      }
      me.btnDisabled = false
    },
    syncMatter(item) {
      this.syncDialog = true
      this.syncModel.planId = item.id
    },
    async handleSync() {
      if (!this.syncValid) {
        this.$dialog.error({
          title: '错误',
          text: '请完善信息'
        })
        return
      }
      let me = this;
      me.btnDisabled = true
      let res = await ShopPlanApi.sync(me.syncModel);
      if (res.data.code === 200) {
        me.$dialog.info({
          text: res.data.msg,
          title: "操作成功",
        });
        me.hideSync()
      } else {
        me.$dialog.error({
          text: res.data.msg_detail,
          title: res.data.msg,
        });
      }
      me.btnDisabled = false
    },
    hideSync() {
      this.syncDialog = false
      this.syncModel = {
        planId: null,
        matterIds: null
      }
    },
    _hasButtonPermission(name) {
      let buttonPriviledgeList = this.buttonPriviledgeList;
      let hasButton = false;
      for (let i = 0; i < buttonPriviledgeList.length; i++) {
        if (buttonPriviledgeList[i].name == name) {
          if (buttonPriviledgeList[i].hasPriviledge == "Y") {
            return true;
          } else {
            return false;
          }
        }
      }
      return false;
    },
    _jungleStatus(status) {
      return this.statusMap['' + status]
    }
  },
};
</script>
<style scoped>

</style>